import {CanActivateFn, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {inject} from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const authService: AuthService = inject(AuthService);
  const routerService: Router = inject(Router);

  if (authService.isLoggedIn()) { return true; }

  routerService.navigate(['/login']).then();
  return false;
};
